import { render, staticRenderFns } from "./PageGroupsTable.vue?vue&type=template&id=0006b145&"
import script from "./PageGroupsTable.vue?vue&type=script&lang=ts&"
export * from "./PageGroupsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PageGroupsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports